import { NoDataEnDash } from '@packages/components/no-data-en-dash/no-data-en-dash';
import type { GridRenderCellParams } from '@packages/fenrir/components/datagrid';
import { Tooltip } from '@packages/fenrir/components/tooltip';
import { Typography } from '@packages/fenrir/components/typography';

export const StringCell = (params: GridRenderCellParams) => {
  return params.value || params.value === 0 ? (
    <Tooltip title={params.value}>
      <Typography variant="body2" noWrap>
        {params.value}
      </Typography>
    </Tooltip>
  ) : (
    <NoDataEnDash />
  );
};
